import { authSplitApi } from 'redux/helpers/slice.helpers';
import { TCourse } from 'data/types/curriculum.types';

const PM_BASE = 'property_manager/api/v2/curriculum';

export const curriculumApi = authSplitApi('curriculumApi', ['courses', 'courses_landlord']).injectEndpoints({
  endpoints: (build) => ({
    getCoursesLandlord: build.query<TCourse[], void>({
      query: () => ({
        url: `${PM_BASE}`,
        method: 'GET',
      }),
      providesTags: ['courses_landlord'],
    }),

    getCourseLandlord: build.query<TCourse, { id: string }>({
      query: ({ id }) => ({
        url: `${PM_BASE}/${id}`,
        method: 'GET',
      }),
      providesTags: ['courses_landlord'],
    }),
  }),
  overrideExisting: false,
});

export const { useGetCoursesLandlordQuery, useGetCourseLandlordQuery } = curriculumApi;
